<!--
 * @Author: your name
 * @Date: 2021-08-12 09:31:52
 * @LastEditTime: 2021-08-12 09:35:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kr-health-manage\src\views\prescription\PrescriptionDetails\sport\rest\index.vue
-->
<template>
  <div class="rest">
    <img src="@/assets/img/no-sport.png" alt="" />
    <span>休息日</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.rest {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.2rem 0;
  }
  span {
    width: 3rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border-radius: 0.1rem;
    color: cornflowerblue;
    font-size: 0.3rem;
    text-align: center;
  }
}
</style>
